import { roundScore } from './evaluationScore';

export const formatScore = (score: number | null): string =>
  score === null ? '–' : roundScore(score).toFixed(1).replace('.', ',');

// Only the migrated payload carries evaluationCount, so its presence decides the look.
export const isMigratedRow = (row: { evaluationCount?: number }): boolean =>
  row.evaluationCount !== undefined;

export type TrendDelta = { delta: number; percent: number };

const roundHalfAwayFromZero = (x: number): number => {
  const rounded = Math.sign(x) * roundScore(Math.abs(x));
  return rounded === 0 ? 0 : rounded;
};

export const trendDelta = (points: { score: number }[]): TrendDelta | null => {
  if (points.length < 2) return null;
  const first = points[0].score;
  const delta = points[points.length - 1].score - first;
  return {
    delta: roundHalfAwayFromZero(delta),
    percent: roundHalfAwayFromZero((delta / first) * 100),
  };
};
